export const constants = {
  VERIFY_OTP_ENDPOINT: '/api/sign-in-service/v1/step-up/verify',
  SEND_OTP_ENDPOINT: '/api/sign-in-service/v1/step-up/otp',
  VERIFY_QNA_ENDPOINT: '/api/sign-in-service/v1/step-up/qna',
};

export const QUESTION_VERIFICATION_RESPONSE = 'QUESTION_VERIFICATION_RESPONSE';
